// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mH","editButton":"mI","formClass":"mJ","rowClass":"mK","columnClass":"mL","inputClass":"mM","email":"mN","mobile":"mO","cancelButton":"mP","submitButton":"mQ"};